import { createGlobalStyle } from 'styled-components';
/**
 * pointer-events: none and cursor won't work together
 * since pointer-events will disable all mouse events which will prevent cursor style
 */ export const disabledStyles = createGlobalStyle`
  *[data-preview-disable='true'],
  *[contenteditable='true'],
  button:where(:not(.ant-drawer-close)):where(:not(.ant-modal-close)):where(:not([data-cy='cp.preview_mode.nav_bar.share_button'])):where(:not([data-cy='cp.invite_to_project_modal.copy_link_button'])):where(:not([data-cy='image-preview.close-button'])):where(:not([data-cy*='sheets.tab.'])):where(:not([data-cy*='sheets.pivot.tab.button.'])):where(:not([data-cy='sheets.new.pivot'])):where(:not([data-cy='sheets.back.overview'])):where(:not([data-cy='sheets.overview'])),
  input,
  textarea,
  select,
  label,
  .ozone-select-container,
  .ant-dropdown-trigger:where(:not([data-cy*='sheets.tab.'])):where(:not([data-cy*='sheets.pivot.tab.button.'])):where(:not([data-cy='sheets.new.pivot'])):where(:not([data-cy='sheets.back.overview'])):where(:not([data-cy='sheets.overview'])),
  .ant-upload-select,
  .ant-upload-drag,
  .ant-slider,
  .ant-picker,
  .ant-input-number,
  .ag-center-cols-container .ag-row,
  .status-indicator.task-field-value,
  *[class*='rich-text-editor'],
  *[class*='overview'] a {
    pointer-events: none !important;
  }

  *[data-preview-enable="true"] button,
  *[data-preview-enable="true"] input,
  *[data-preview-enable="true"] textarea,
  *[data-preview-enable="true"] select,
  *[data-preview-enable="true"] label,
  .ant-dropdown-trigger.more-responsible-filters,
  .column-list-popover-modal button {
    pointer-events: inherit !important;
  }

  *[data-preview-hide] {
    display: none !important;
  }
`;
